import { render } from "./GameEditHeader.vue?vue&type=template&id=22df7dc0"
import script from "./GameEditHeader.vue?vue&type=script&lang=js"
export * from "./GameEditHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__